<template>
  <div style="padding-top: 3em;">
    <h4 class="title">Application for Events on Reserves &amp; Roads</h4>

    <template v-if="!message">
      <div class="notification is-danger">
        <p>
          Note: This form will need to be completed in its entirety and cannot be saved.
          <br />It will take approximately 15 minutes to complete.
        </p>
      </div>

      <div class="notification is-warning">
        <p>
          <strong>To submit your initial application you will need to upload these manadatory documents:</strong>
        </p>
        <ul>
          <li>- Public Liability Insurance. (Event Organiser)</li>
          <li>- Site Plan of your event. (Draft format is OK)</li>
          <li>- Risk Assessment. (Draft format is OK)</li>
        </ul>

        <p style="margin-top: 1em;">
          <strong>If applicable, these additional documents will be required:</strong>
        </p>
        <ul>
          <li>- Traffic Management Plan</li>
          <li>- Fireworks Documentation</li>
          <li>- Amusements Documentation</li>
          <li>- Community Consultation/Notification</li>
        </ul>
      </div>

      <p class="addPaddingTop1em">
        <a target="_blank" href="https://www.cityofpae.sa.gov.au/?a=413288">
          A Guide for Organising Events in the City of Port Adelaide Enfield
          (PDF)
        </a>
        <br />
        <a
          target="_blank"
          href="https://www.cityofpae.sa.gov.au/?a=410773"
        >PAE Schedule of fees and charges (PDF)</a>
        <br />

        <a
          target="_blank"
          href="https://www.cityofpae.sa.gov.au/live/public-and-environmental-health/local-nuisance"
        >What is a local nuisance (webpage)</a>
        <br />

        <a
          target="_blank"
          href="https://www.cityofpae.sa.gov.au/?a=410924"
        >Process for Road Closure (PDF)</a>
        <br />

        <a
          target="_blank"
          href="http://online.pae.sa.gov.au/onlineform/events-food-safety"
        >Special Events Food Safety Notification Form</a>
        <br />

        <a
          target="_blank"
          href="https://www.cityofpae.sa.gov.au/?a=683914"
        >Risk Assessment Template (PDF)</a> -
        <a target="_blank" href="https://www.cityofpae.sa.gov.au/?a=683925">(DOC)</a>
      </p>

      <hr />

      <p class="addPaddingTop1em">
        <strong>External Websites</strong>
      </p>
      <ul>
        <li>
          <a target="_blank" href="https://www.safework.sa.gov.au/">SafeWork SA</a>
        </li>
        <li>
          <a
            href="https://www.health.gov.au/"
            target="blank"
          >Australian Government Department of Health</a>
        </li>
        <li>
          <a
            href="https://www.sahealth.sa.gov.au/wps/wcm/connect/Public+Content/SA+Health+Internet/"
            target="blank"
          >Health SA</a>
        </li>
        <li>
          <a
            href="https://www.localcommunityinsurance.com.au/documents/LCIS_Community_Event_Risk_Management_Checklist.pdf"
            target="blank"
          >Local Community Insurance Services</a>
        </li>
        <li>
          <a href="https://www.sa.gov.au/" target="blank">SA Government</a>
        </li>
        <li>
          <a
            href="https://www.covid-19.sa.gov.au/recovery/create-a-covid-safe-plan"
            target="blank"
          >How to create a COVID- Safe Plan</a>
        </li>
      </ul>

      <p style="margin-top: 1em;">
        <strong>For further information you can review the following:</strong>
      </p>
      <p>There are many suppliers of Public Liability but here are some links that may be able to assist you</p>
      <ul>
        <li>
          <a
            target="_blank"
            href="https://www.duckforcover.com.au/html/"
          >www.duckforcover.com.au/html/</a>
        </li>
        <li>
          <a
            target="_blank"
            href="http://www.localcommunityinsurance.com.au/"
          >www.localcommunityinsurance.com.au/</a>
        </li>
      </ul>

      <br />
    </template>

    <div v-if="message" class="notification is-primary">{{ message }}</div>

    <form-wizard
      dusk="form-wizard"
      @submit.prevent="onSubmit"
      @on-complete="onSubmit"
      shape="tab"
      color="#17C4EE"
      title
      subtitle
      ref="wizard"
      v-if="!message"
    >
      <input type="hidden" name="_token" :value="csrf" />
      <input type="hidden" v-model="form" />

      <div style="padding: 1em 0px; color: #aaa;">
        <small>* Required Fields</small>
      </div>

      <!-- ************************* -->
      <!-- TAB #1 - INCIDENT DETAILS -->
      <!-- ************************* -->
      <tab-content title="Applicant Details" :before-change="validateStep1">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label" style="margin:0;">Legal Entity Name *</label>
              <small>This must be the same name as the person who holds the Public Liability for the event</small>
              <div class="control">
                <input
                  type="text"
                  :status="$v.legalEntityName.$error ? 'error' : null"
                  placeholder="Please enter the legal entity name"
                  :class="{ 'input': true, 'is-danger': $v.legalEntityName.$error }"
                  @blur="$v.legalEntityName.$touch()"
                  id="legalEntityName"
                  name="legalEntityName"
                  v-model="legalEntityName"
                />
                <span
                  v-if="$v.legalEntityName.$error && !$v.legalEntityName.required"
                  class="help is-danger"
                >
                  Legal
                  entity name is required
                </span>
                <span
                  v-if="$v.legalEntityName.$error && !$v.legalEntityName.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Legal Entity Type *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="legalEntityType"
                    name="legalEntityType"
                    v-model="legalEntityType"
                    :class="{ 'is-danger': $v.legalEntityType.$error }"
                    @blur="$v.legalEntityType.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Unincorporated Group</option>
                    <option>Registered Company</option>
                    <option>Incorporation Association</option>
                    <option>Partnership</option>
                  </select>
                </div>
                <span
                  v-if="$v.legalEntityType.$error && !$v.legalEntityType.required"
                  class="help is-danger"
                >
                  Legal
                  entity type is required
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">Applicant First Name *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter applicants first name"
                  :class="{ 'input': true, 'is-danger': $v.applicantFirstName.$error }"
                  @blur="$v.applicantFirstName.$touch()"
                  id="applicantFirstName"
                  name="applicantFirstName"
                  v-model="applicantFirstName"
                />
                <span
                  v-if="$v.applicantFirstName.$error && !$v.applicantFirstName.required"
                  class="help is-danger"
                >First name is required</span>
                <span
                  v-if="$v.applicantFirstName.$error && !$v.applicantFirstName.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">Applicant Last Name *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter applicants last name"
                  :class="{ 'input': true, 'is-danger': $v.applicantLastName.$error }"
                  @blur="$v.applicantLastName.$touch()"
                  id="applicantLastName"
                  name="applicantLastName"
                  v-model="applicantLastName"
                />
                <span
                  v-if="$v.applicantLastName.$error && !$v.applicantLastName.required"
                  class="help is-danger"
                >
                  Last
                  name is required
                </span>
                <span
                  v-if="$v.applicantLastName.$error && !$v.applicantLastName.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">Applicant Position in the Company *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter applicants position"
                  :class="{ 'input': true, 'is-danger': $v.applicantPosition.$error }"
                  @blur="$v.applicantPosition.$touch()"
                  id="applicantPosition"
                  name="applicantPosition"
                  v-model="applicantPosition"
                />
                <span
                  v-if="$v.applicantPosition.$error && !$v.applicantPosition.required"
                  class="help is-danger"
                >Position is required</span>
                <span
                  v-if="$v.applicantPosition.$error && !$v.applicantPosition.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label">Applicant Contact Number *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter contact number"
                  :class="{ 'input': true, 'is-danger': $v.applicantContactNumber.$error }"
                  @blur="$v.applicantContactNumber.$touch()"
                  id="applicantContactNumber"
                  name="applicantContactNumber"
                  v-model="applicantContactNumber"
                />
                <span
                  v-if="$v.applicantContactNumber.$error && !$v.applicantContactNumber.required"
                  class="help is-danger"
                >Contact number is required</span>
                <span
                  v-if="$v.applicantContactNumber.$error && !$v.applicantContactNumber.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">Applicant Email Address *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter email address"
                  :class="{ 'input': true, 'is-danger': $v.applicantEmail.$error }"
                  @blur="$v.applicantEmail.$touch()"
                  id="applicantEmail"
                  name="applicantEmail"
                  v-model="applicantEmail"
                />
                <span
                  v-if="$v.applicantEmail.$error && !$v.applicantEmail.required"
                  class="help is-danger"
                >
                  Email
                  address is required
                </span>
                <span
                  v-if="$v.applicantEmail.$error && !$v.applicantEmail.email"
                  class="help is-danger"
                >
                  Format
                  incorrect
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Applicant Postal Address</label>

              <div class="box" style="background: #fefefe; margin-top: .5em;">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="form-check">
                      <strong>Is the address within the City of Port Adelaide Enfield area (or a PO Box)?</strong>
                      <div class="control">
                        <label class="radio">
                          <input
                            type="radio"
                            name="applicantPostalAddressPAE"
                            v-model="applicantPostalAddressPAE"
                            @blur="$v.applicantPostalAddressPAE.$touch()"
                            value="1"
                          />
                          Yes
                        </label>
                        <label class="radio">
                          <input
                            type="radio"
                            name="applicantPostalAddressPAE"
                            v-model="applicantPostalAddressPAE"
                            @blur="$v.applicantPostalAddressPAE.$touch()"
                            value="0"
                          />
                          No
                        </label>

                        <label class="radio">
                          <input
                            type="radio"
                            name="applicantPostalAddressPAE"
                            v-model="applicantPostalAddressPAE"
                            @blur="$v.applicantPostalAddressPAE.$touch()"
                            value="2"
                          />
                          PO Box
                        </label>

                        <template v-if="applicantPostalAddressPAE == 99">
                          <span v-if="$v.applicantPostalAddressPAE.$error" class="help is-danger">
                            Please select an
                            option.
                          </span>
                        </template>
                      </div>
                    </div>
                  </div>

                  <div class="field column is-12 test">
                    <template v-if="applicantPostalAddressPAE <= 2">
                      <template v-if="applicantPostalAddressPAE == 1">
                        <label class="label">
                          Address
                          <small class="has-text-weight-light">
                            <strong>(Select from suggested address in dropdown list)</strong>
                          </small> *
                        </label>
                        <div class="control">
                          <PropertyAddress
                            fieldName="applicantPostalAddress"
                            source="/api/address/search"
                            placeholder="eg. 1/10 Main St Semaphore"
                            v-on:address="saveApplicantPostalAddress"
                            v-on:addressTyping="saveApplicantPostalAddressTyping"
                            v-on:addressPropertyNo="saveApplicantPostalAddressPropertyNo"
                          ></PropertyAddress>
                          <div
                            v-if="applicantPostalAddressPropertyNo==0 && applicantPostalAddressTyping.length>0"
                            style="background: #eee; padding: 1em;"
                          >
                            <small>
                              Please type address in full and then select correct address from the drop down list.
                              <br />eg. 1/10 Main St Semaphore SA 5091
                            </small>
                            <template
                              v-if="$v.applicantPostalAddressPropertyNo.$error || this.applicantPostalAddressNotFound == true"
                            >
                              (
                              <input
                                type="checkbox"
                                id="applicantPostalAddressNotFound"
                                v-model="applicantPostalAddressNotFound"
                              />
                              <label for="applicantPostalAddressNotFound">
                                <small>I cannot find my address in the dropdown list.</small>
                              </label> )
                            </template>
                          </div>
                          <span
                            v-if="$v.applicantPostalAddressPropertyNo.$error"
                            class="help is-danger"
                          >
                            Valid address
                            is required. (Please select from dropdown list as you type)
                          </span>
                        </div>
                      </template>

                      <template v-if="applicantPostalAddressPAE == 0">
                        <label class="label">
                          Address
                          <small
                            class="has-text-weight-light"
                          >(Outside of the City of Port Adelaide Enfield)</small> *
                        </label>
                        <div class="control">
                          <GoogleAddressAutocomplete
                            fieldName="applicantPostalAddress"
                            placeholder="eg. 1/10 Main St, Semaphore"
                            v-on:address="saveApplicantPostalAddress"
                            v-on:addressTyping="saveApplicantPostalAddressTyping"
                            v-on:addressPropertyNo="saveApplicantPostalAddressPropertyNo"
                          ></GoogleAddressAutocomplete>
                          <span v-if="$v.applicantPostalAddress.$error" class="help is-danger">
                            Valid address is
                            required.
                          </span>
                        </div>
                      </template>

                      <template v-if="applicantPostalAddressPAE == 2">
                        <label class="label">PO Box *</label>
                        <div class="control">
                          <input
                            type="text"
                            placeholder="Please enter the PO Box number"
                            :class="{ 'input': true, 'is-danger': $v.applicantPostalAddress.$error }"
                            @blur="$v.applicantPostalAddress.$touch()"
                            name="applicantPostalAddress"
                            v-model="applicantPostalAddress"
                          />
                          <span
                            v-if="$v.applicantPostalAddress.$error && !$v.applicantPostalAddress.required"
                            class="help is-danger"
                          >PO Box is required</span>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
      </tab-content>

      <tab-content title="Event Details" :before-change="validateStep2">
        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Event Location *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="eventLocationType"
                    name="eventLocationType"
                    v-model="eventLocationType"
                    :class="{ 'is-danger': $v.eventLocationType.$error }"
                    @blur="$v.eventLocationType.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Reserve</option>
                    <option>Street Address</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventLocationType.$error && !$v.eventLocationType.required"
                  class="help is-danger"
                >Location is required</span>
              </div>
            </div>
          </div>
        </div>

        <template v-if="eventLocationType == 'Reserve'">
          <div class="box" style="background: #eee; padding: 1em; padding-bottom: 2em;">
            <div class="columns">
              <div class="field column is-5">
                <label class="label">
                  Reserve
                  <small
                    class="has-text-weight-light"
                  >(Within the City of Port Adelaide Enfield)</small> *
                </label>
                <div class="control">
                  <div class="select" :class="{ 'is-danger': $v.eventLocation.$error }">
                    <select
                      v-model="reserveName"
                      v-on:change="saveEventLocation(reserveName)"
                      @blur="$v.eventLocation.$touch()"
                    >
                      <option selected :value="null">--Please select--</option>
                      <option>Bennett Memorial Reserve (Manningham)</option>
                      <option>Fotheringham Reserve (Osborne)</option>
                      <option>Harry Wierda Reserve (Oakden)</option>
                      <option>L J Lewis Park (Northfield)</option>
                      <option>Regency Park Reserve (Regency Park)</option>
                      <option>Semaphore Foreshore Reserve (Semaphore)</option>
                      <option>Semaphore South Foreshore (Semaphore South)</option>
                      <option>St Patricks Reserve (Alberton)</option>
                      <option>Other...</option>
                    </select>
                  </div>
                  <span
                    v-if="$v.eventLocation.$error"
                    class="help is-danger"
                  >Valid reserve is required.</span>
                </div>
              </div>
            </div>

            <div class="columns" v-if="reserveName=='Other...'">
              <div class="column is-4">
                <div class="field">
                  <label class="label">Name of Reserve *</label>
                  <div class="control">
                    <input
                      type="text"
                      placeholder="Please enter the name of the reserve"
                      :class="{ 'input': true, 'is-danger': $v.eventLocationOtherReserve.$error }"
                      @blur="$v.eventLocationOtherReserve.$touch()"
                      name="eventLocationOtherReserve"
                      v-model="eventLocationOtherReserve"
                      v-on:change="saveEventLocation(eventLocationOtherReserve)"
                    />
                    <span
                      v-if="$v.eventLocationOtherReserve.$error && !$v.eventLocationOtherReserve.required"
                      class="help is-danger"
                    >Reserve name is required</span>
                    <span
                      v-if="$v.eventLocationOtherReserve.$error && !$v.eventLocationOtherReserve.AlphNumCharsValidator"
                      class="help is-danger"
                    >Invalid characters entered</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-8">
                <div class="field">
                  <label class="label">
                    Will you require keys to the reserve?
                    <small
                      class="has-text-weight-light"
                    >(Associated bond/fees will be passed on)</small> *
                  </label>
                  <div class="control">
                    <div
                      class="select"
                      :class="{ 'is-danger': $v.eventLocationReserveKeys.$error }"
                    >
                      <select
                        name="eventLocationReserveKeys"
                        v-model="eventLocationReserveKeys"
                        :class="{ 'is-danger': $v.eventLocationReserveKeys.$error }"
                        @blur="$v.eventLocationReserveKeys.$touch()"
                      >
                        <option :value="null">--Please select--</option>
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <span
                      v-if="$v.eventLocationReserveKeys.$error && !$v.eventLocationReserveKeys.required"
                      class="help is-danger"
                    >Please select an option</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-8">
                <div class="field">
                  <label class="label">
                    Will you require access to onsite electricity?
                    <small
                      class="has-text-weight-light"
                    >(Associated bond/fees will be passed on)</small> *
                  </label>
                  <div class="control">
                    <div
                      class="select"
                      :class="{ 'is-danger': $v.eventLocationReserveElectricity.$error }"
                    >
                      <select
                        name="eventLocationReserveElectricity"
                        v-model="eventLocationReserveElectricity"
                        :class="{ 'is-danger': $v.eventLocationReserveElectricity.$error }"
                        @blur="$v.eventLocationReserveElectricity.$touch()"
                      >
                        <option selected :value="null">--Please select--</option>
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <span
                      v-if="$v.eventLocationReserveElectricity.$error && !$v.eventLocationReserveElectricity.required"
                      class="help is-danger"
                    >Please select an option</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="eventLocationType == 'Street Address'">
          <div class="box" style="background: #eee;">
            <div class="columns">
              <div class="field column is-7">
                <label class="label">Address of Event *</label>
                <div class="control">
                  <input
                    type="text"
                    placeholder="Please enter the address of the event"
                    :class="{ 'input': true, 'is-danger': $v.eventLocation.$error }"
                    @blur="$v.eventLocation.$touch()"
                    name="eventLocation"
                    v-model="eventLocation"
                  />
                  <span
                    v-if="$v.eventLocation.$error && !$v.eventLocation.required"
                    class="help is-danger"
                  >
                    Event
                    address is required
                  </span>
                  <span
                    v-if="$v.eventLocation.$error && !$v.eventLocation.AlphNumCharsValidator"
                    class="help is-danger"
                  >Invalid characters entered</span>
                </div>
              </div>
              <br />
            </div>
          </div>
        </template>

        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">Event Name *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="Please enter the name of the event"
                  :class="{ 'input': true, 'is-danger': $v.eventName.$error }"
                  @blur="$v.eventName.$touch()"
                  id="eventName"
                  name="eventName"
                  v-model="eventName"
                />
                <span v-if="$v.eventName.$error && !$v.eventName.required" class="help is-danger">
                  Event name is
                  required
                </span>
                <span
                  v-if="$v.eventName.$error && !$v.eventName.AlphNumCharsValidator"
                  class="help is-danger"
                >
                  Invalid
                  characters entered
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Event Description *</label>
              <div class="control">
                <textarea
                  rows="8"
                  placeholder="Please enter the description of the event"
                  :class="{ 'textarea': true, 'is-danger': $v.eventDescription.$error }"
                  @blur="$v.eventDescription.$touch()"
                  id="eventDescription"
                  name="eventDescription"
                  v-model="eventDescription"
                ></textarea>
                <span
                  v-if="$v.eventDescription.$error && !$v.eventDescription.required"
                  class="help is-danger"
                >
                  Event
                  description is required
                </span>
                <span
                  v-if="$v.eventDescription.$error && !$v.eventDescription.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="columns" style="margin-bottom: 0px;">
              <div class="column is-3" style="padding-bottom: 0px;">
                <div class="field">
                  <label class="label">Bump In Dates *</label>
                </div>
              </div>
            </div>

            <div class="box" style="background: #fefefe; margin-top: .5em;">
              <div
                class="columns is-multiline"
                v-for="(bumpindate, index) in eventBumpInDates"
                :key="index"
              >
                <div class="column is-10">
                  <div class="field">
                    <div class="control" style="vertical-align: middle;">
                      <datepicker
                        :format="customFormatter"
                        id="datepicker"
                        :disabled-dates="disabled"
                        :input-class="'input'"
                        style="float: left; margin-right:1em; width: 110px;"
                        placeholder="Select date"
                        v-model="bumpindate.date"
                      ></datepicker>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventBumpInDates.$touch()"
                        v-model="bumpindate.timeFrom"
                      />
                      <small style="vertical-align: -webkit-baseline-middle;">-</small>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventBumpInDates.$touch()"
                        v-model="bumpindate.timeTo"
                      />
                      <button
                        class="button"
                        @click="eventBumpInDates.pop()"
                        v-if="index+1 == eventBumpInDates.length && index>0"
                      >Remove</button>
                    </div>
                  </div>
                  <span
                    v-if="$v.eventBumpInDates.$each[index].date.$error && !$v.eventBumpInDates.$each[index].date.required"
                    class="help is-danger"
                  >Date is required</span>
                  <span
                    v-if="$v.eventBumpInDates.$each[index].timeFrom.$error && !$v.eventBumpInDates.$each[index].timeFrom.required || $v.eventBumpInDates.$each[index].timeTo.$error && !$v.eventBumpInDates.$each[index].timeTo.required"
                    class="help is-danger"
                  >Time range is required</span>
                </div>
                <div class="column is-2">
                  <div
                    class="field has-addons is-pulled-right"
                    v-if="index+1 == eventBumpInDates.length"
                  >
                    <p class="control">
                      <a class="button is-primary" @click="eventBumpInDates.push({date: ''})">
                        <span class="icon is-small">
                          <i class="fas fa-plus"></i>
                        </span>
                        <span>Day</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="columns" style="margin-bottom: 0px;">
              <div class="column is-3" style="padding-bottom: 0px;">
                <div class="field">
                  <label class="label">Event Dates *</label>
                </div>
              </div>
            </div>

            <div class="box" style="background: #fefefe; margin-top: .5em;">
              <div
                class="columns is-multiline"
                v-for="(eventdate, index) in eventDates"
                :key="index"
              >
                <div class="column is-10">
                  <div class="field">
                    <div class="control" style="vertical-align: middle;">
                      <datepicker
                        :format="customFormatter"
                        id="datepicker"
                        :disabled-dates="disabled"
                        :input-class="'input'"
                        style="float: left; margin-right:1em; width: 110px;"
                        placeholder="Select date"
                        v-model="eventdate.date"
                      ></datepicker>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventDates.$touch()"
                        v-model="eventdate.timeFrom"
                      />
                      <small style="vertical-align: -webkit-baseline-middle;">-</small>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventDates.$touch()"
                        v-model="eventdate.timeTo"
                      />
                      <button
                        class="button"
                        @click="eventDates.pop()"
                        v-if="index+1 == eventDates.length && index>0"
                      >Remove</button>
                    </div>
                  </div>
                  <span
                    v-if="$v.eventDates.$each[index].date.$error && !$v.eventDates.$each[index].date.required"
                    class="help is-danger"
                  >Date is required</span>
                  <span
                    v-if="$v.eventDates.$each[index].timeFrom.$error && !$v.eventDates.$each[index].timeFrom.required || $v.eventDates.$each[index].timeTo.$error && !$v.eventDates.$each[index].timeTo.required"
                    class="help is-danger"
                  >Time range is required</span>
                </div>
                <div class="column is-2">
                  <div class="field has-addons is-pulled-right" v-if="index+1 == eventDates.length">
                    <p class="control">
                      <a class="button is-primary" @click="eventDates.push({date: ''})">
                        <span class="icon is-small">
                          <i class="fas fa-plus"></i>
                        </span>
                        <span>Day</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="columns" style="margin-bottom: 0px;">
              <div class="column is-3" style="padding-bottom: 0px;">
                <div class="field">
                  <label class="label">Bump Out Dates *</label>
                </div>
              </div>
            </div>

            <div class="box" style="background: #fefefe; margin-top: .5em;">
              <div
                class="columns is-multiline"
                v-for="(bumpoutdate, index) in eventBumpOutDates"
                :key="index"
              >
                <div class="column is-10">
                  <div class="field">
                    <div class="control" style="vertical-align: middle;">
                      <datepicker
                        :format="customFormatter"
                        id="datepicker"
                        :disabled-dates="disabled"
                        :input-class="'input'"
                        style="float: left; margin-right:1em; width: 110px;"
                        placeholder="Select date"
                        v-model="bumpoutdate.date"
                      ></datepicker>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventBumpOutDates.$touch()"
                        v-model="bumpoutdate.timeFrom"
                      />
                      <small style="vertical-align: -webkit-baseline-middle;">-</small>
                      <input
                        ref="timeField"
                        style="width: 70px;"
                        type="text"
                        placeholder="hh:mm"
                        :class="{ 'input': true }"
                        @blur="$v.eventBumpOutDates.$touch()"
                        v-model="bumpoutdate.timeTo"
                      />
                      <button
                        class="button"
                        @click="eventBumpOutDates.pop()"
                        v-if="index+1 == eventBumpOutDates.length && index>0"
                      >Remove</button>
                    </div>
                  </div>
                  <span
                    v-if="$v.eventBumpOutDates.$each[index].date.$error && !$v.eventBumpOutDates.$each[index].date.required"
                    class="help is-danger"
                  >Date is required</span>
                  <span
                    v-if="$v.eventBumpOutDates.$each[index].timeFrom.$error && !$v.eventBumpOutDates.$each[index].timeFrom.required || $v.eventBumpOutDates.$each[index].timeTo.$error && !$v.eventBumpOutDates.$each[index].timeTo.required"
                    class="help is-danger"
                  >Time range is required</span>
                </div>
                <div class="column is-2">
                  <div
                    class="field has-addons is-pulled-right"
                    v-if="index+1 == eventBumpOutDates.length"
                  >
                    <p class="control">
                      <a class="button is-primary" @click="eventBumpOutDates.push({date: ''})">
                        <span class="icon is-small">
                          <i class="fas fa-plus"></i>
                        </span>
                        <span>Day</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <label class="label">Please attach site/area map</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Is the event open to the Public *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="eventPublic"
                    v-model="eventPublic"
                    :class="{ 'is-danger': $v.eventPublic.$error }"
                    @blur="$v.eventPublic.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventPublic.$error && !$v.eventPublic.required"
                  class="help is-danger"
                >
                  This is
                  required
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Type of Event *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="eventType"
                    v-model="eventType"
                    :class="{ 'is-danger': $v.eventType.$error }"
                    @blur="$v.eventType.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Commercial</option>
                    <option>Community</option>
                  </select>
                </div>
                <span v-if="$v.eventType.$error && !$v.eventType.required" class="help is-danger">
                  Event type is
                  required
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">Estimated Attendance per day *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="0"
                  style="width: 80px;"
                  :class="{ 'input': true, 'is-danger': $v.eventEstimatedAttendance.$error }"
                  @blur="$v.eventEstimatedAttendance.$touch()"
                  name="eventEstimatedAttendance"
                  v-model="eventEstimatedAttendance"
                />
                <span
                  v-if="$v.eventEstimatedAttendance.$error && !$v.eventEstimatedAttendance.required"
                  class="help is-danger"
                >Estimated attendance is required</span>
                <span
                  v-if="$v.eventEstimatedAttendance.$error && !$v.eventEstimatedAttendance.numeric"
                  class="help is-danger"
                >Invalid number</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="columns" style="margin-bottom: 0px;">
              <div class="column is-8" style="padding-bottom: 0px;">
                <div class="field">
                  <label class="label">Admission/Ticket Fee Structure *</label>
                </div>
              </div>
            </div>

            <div class="box" style="background: #fefefe; margin-top: .5em;">
              <div
                class="columns is-multiline"
                v-for="(ticket, index) in eventTickets"
                :key="index"
              >
                <div class="column is-10">
                  <div class="field">
                    <div class="control" style="display: inline;">
                      <input
                        style="width: 330px;"
                        type="text"
                        :name="'eventTicketsType'+index"
                        placeholder="eg. General Admission"
                        :class="{ 'input': true }"
                        @blur="$v.eventTickets.$touch()"
                        v-model="ticket.type"
                      />
                    </div>
                    <p class="control has-icons-left" style="display:inline;">
                      <input
                        style="width: 100px;"
                        type="text"
                        :name="'eventTicketsPrice'+index"
                        placeholder="5.00"
                        :class="{ 'input': true }"
                        @blur="$v.eventTickets.$touch()"
                        v-model="ticket.price"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-dollar-sign"></i>
                      </span>
                    </p>
                    <div class="control" style="display:inline;">
                      <button
                        class="button"
                        @click="eventTickets.pop()"
                        v-if="index+1 == eventTickets.length && index>0"
                      >Remove</button>
                    </div>
                  </div>
                  <span
                    v-if="$v.eventTickets.$each[index].type.$error && !$v.eventTickets.$each[index].type.required"
                    class="help is-danger"
                  >Ticket type is required</span>
                  <span
                    v-if="$v.eventTickets.$each[index].price.$error && !$v.eventTickets.$each[index].price.required"
                    class="help is-danger"
                  >Ticket price is required</span>
                </div>
                <div class="column is-2">
                  <div
                    class="field has-addons is-pulled-right"
                    v-if="index+1 == eventTickets.length"
                  >
                    <p class="control">
                      <a
                        class="button is-primary addTicket"
                        name="addTicket"
                        @click="eventTickets.push({type: ''})"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-plus"></i>
                        </span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Select Other Elements *</label>

              <div
                style="margin-bottom: 1em;"
                v-if="$v.eventElementsSelected.$error && !$v.eventElementsSelected.required && !eventElementsOther"
              >
                <span class="help is-danger">You must select an option..</span>
              </div>

              <div
                v-for="element in eventElements"
                class="control level is-marginless"
                :key="element.id"
              >
                <div class="level-left">
                  <a
                    class="button btnElements level-item"
                    :id="'elements'+element.name"
                    :class="{ 'is-success': element.enabled }"
                    @click="element.enabled = !element.enabled"
                  >{{ element.label }}</a>
                  <small
                    class="level-item"
                    style="clear:both;"
                    v-if="element.example"
                  >Eg. {{ element.example }}</small>
                </div>
              </div>

              <div class="control level is-marginless">
                <div class="level-left">
                  <a
                    class="button btnElements level-item"
                    id="elementsOther"
                    :class="{ 'is-success': eventElementsOther }"
                    @click="eventElementsOther = !eventElementsOther"
                  >Other</a>
                </div>
              </div>

              <textarea
                v-if="eventElementsOther"
                rows="5"
                placeholder="Please enter other elements"
                :class="{ 'textarea': true, 'is-danger': $v.eventElementsOtherDescription.$error }"
                @blur="$v.eventElementsOtherDescription.$touch()"
                id="eventElementsOtherDescription"
                name="eventElementsOtherDescription"
                v-model="eventElementsOtherDescription"
              ></textarea>
              <span
                v-if="$v.eventElementsOtherDescription.$error && !$v.eventElementsOtherDescription.required"
                class="help is-danger"
              >Description is required</span>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">How will you be marketing the event? *</label>

              <div
                style="margin-bottom: 1em;"
                v-if="$v.eventMarketingItemsSelected.$error && !$v.eventMarketingItemsSelected.required && !eventMarketingItemsOther"
              >
                <span class="help is-danger">You must select an option</span>
              </div>

              <a
                v-for="item in eventMarketingItems"
                :key="item.id"
                class="button btnElements"
                :id="'marketing'+item.name"
                :class="{ 'is-success': item.enabled }"
                @click="item.enabled = !item.enabled"
              >{{ item.label }}</a>
              <a
                class="button btnElements"
                id="eventMarketingItemsOther"
                :class="{ 'is-success': eventMarketingItemsOther }"
                @click="eventMarketingItemsOther = !eventMarketingItemsOther"
              >Other</a>

              <textarea
                v-if="eventMarketingItemsOther"
                rows="3"
                placeholder="Please enter details"
                :class="{ 'textarea': true, 'is-danger': $v.eventMarketingItemsOtherDescription.$error }"
                @blur="$v.eventMarketingItemsOtherDescription.$touch()"
                id="eventMarketingItemsOtherDescription"
                name="eventMarketingItemsOtherDescription"
                v-model="eventMarketingItemsOtherDescription"
              ></textarea>
              <span
                v-if="$v.eventMarketingItemsOtherDescription.$error && !$v.eventMarketingItemsOtherDescription.required"
                class="help is-danger"
              >Description is required</span>

              <div
                v-if="eventMarketingItemsSelected.includes('Social Media') || eventMarketingItemsSelected.includes('Website')"
              >
                <p style="padding-top: .5em;">
                  <label class="label">Please list websites:</label>
                </p>
                <div
                  class="field"
                  v-for="(websites, index) in eventMarketingItemsWebsites"
                  :key="index"
                >
                  <div class="control" style="vertical-align: middle;">
                    <input
                      style="width: 300px;"
                      type="text"
                      :class="{ 'input': true }"
                      name="eventMarketingItemsWebsites"
                      v-model="websites.url"
                      placeholder="www.website.com"
                      @blur="$v.eventMarketingItemsWebsites.$touch()"
                    />
                    <button
                      class="button"
                      @click="eventMarketingItemsWebsites.pop()"
                      v-if="index+1 == eventMarketingItemsWebsites.length && index>0"
                    >Remove</button>
                  </div>
                </div>
                <p class="control">
                  <a class="button is-primary" @click="eventMarketingItemsWebsites.push({url: ''})">
                    <span class="icon is-small">
                      <i class="fas fa-plus"></i>
                    </span>
                    <span>URL</span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <label class="label">Please Attach Marketing Material</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">Has Council Provided Grant/Sponsorship Funding for your Event? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    name="eventCouncilFundedGrant"
                    v-model="eventCouncilFundedGrant"
                    :class="{ 'is-danger': $v.eventCouncilFundedGrant.$error }"
                    @blur="$v.eventCouncilFundedGrant.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventCouncilFundedGrant.$error && !$v.eventCouncilFundedGrant.required"
                  class="help is-danger"
                >This is required</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div
              class="box"
              style="background: #eee; padding-bottom: 2em;"
              v-if="eventCouncilFundedGrant == 'Yes'"
            >
              <div class="columns">
                <div class="column is-12">
                  <label class="label">Enter Name of Grant and Funded Amount *</label>
                  <div class="field level" style="margin-bottom: 0px;">
                    <div class="control level-item" style="padding-right:1em;">
                      <input
                        type="text"
                        placeholder="Please enter name of grant"
                        :class="{ 'input': true }"
                        name="eventCouncilFundedGrantName"
                        v-model="eventCouncilFundedGrantName"
                        @blur="$v.eventCouncilFundedGrantName.$touch()"
                      />
                    </div>
                    <p class="control has-icons-left level-item-right">
                      <input
                        style="width: 130px;"
                        type="text"
                        placeholder="0.00"
                        :class="{ 'input': true }"
                        name="eventCouncilFundedGrantAmount"
                        v-model="eventCouncilFundedGrantAmount"
                        @blur="$v.eventCouncilFundedGrantAmount.$touch()"
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-dollar-sign"></i>
                      </span>
                    </p>
                  </div>
                  <span
                    v-if="$v.eventCouncilFundedGrantName.$error && !$v.eventCouncilFundedGrantName.required"
                    class="help is-danger"
                  >Name of grant is required</span>
                  <span
                    v-if="$v.eventCouncilFundedGrantAmount.$error && !$v.eventCouncilFundedGrantAmount.required"
                    class="help is-danger"
                  >Amount funded is required</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
      </tab-content>

      <tab-content title="Documents &amp; Confirmations" :before-change="validateStep3">
        <div class="columns">
          <div class="column is-8">
            <label class="label">
              Please attach a copy of your current 'in date' public liability insurance.
              <br />
              <small style="font-weight: normal;">
                (which covers the event to the minimum level of $10 million
                claim)
              </small>
            </label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <label class="label">Please attach a copy of your event risk management.</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Have you notified the relevant emergency services? * (i.e. SA Police, SA Ambulance,
                SA Metropolitan Fire Service…)
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="notifiedEmergencyServices"
                    name="notifiedEmergencyServices"
                    v-model="notifiedEmergencyServices"
                    :class="{ 'is-danger': $v.notifiedEmergencyServices.$error }"
                    @blur="$v.notifiedEmergencyServices.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.notifiedEmergencyServices.$error && !$v.notifiedEmergencyServices.required"
                  class="help is-danger"
                >Please select an option</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label
                class="label"
              >Will you have qualified and licensed security personnel present? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="securityPersonnelPresent"
                    name="securityPersonnelPresent"
                    v-model="securityPersonnelPresent"
                    :class="{ 'is-danger': $v.securityPersonnelPresent.$error }"
                    @blur="$v.securityPersonnelPresent.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.securityPersonnelPresent.$error && !$v.securityPersonnelPresent.required"
                  class="help is-danger"
                >Please select an option</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Will your event include any amusements, amusement structures, or jumping castle with
                a platform height of 3m or more? *
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="eventAmusements"
                    name="eventAmusements"
                    v-model="eventAmusements"
                    :class="{ 'is-danger': $v.eventAmusements.$error }"
                    @blur="$v.eventAmusements.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventAmusements.$error && !$v.eventAmusements.required"
                  class="help is-danger"
                >
                  Please
                  select an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="eventAmusements == 'Yes'">
          <div class="column is-8">
            <label class="label">Please attach a copy the following documents for each amusement.</label>
            <ol style="margin-left: 1em; margin-bottom: 1em; font-size: .8em;">
              <li>Public liability insurance certificate,</li>
              <li>Safework SA certificate.</li>
            </ol>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Do you require Council to mark out underground irrigation systems on the reserve? *
                (Associated fee may be passed on)
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="irrigationMarkout"
                    name="irrigationMarkout"
                    v-model="irrigationMarkout"
                    :class="{ 'is-danger': $v.irrigationMarkout.$error }"
                    @blur="$v.irrigationMarkout.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.irrigationMarkout.$error && !$v.irrigationMarkout.required"
                  class="help is-danger"
                >
                  Please
                  select an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="irrigationMarkout == 'Yes'">
          <div class="column is-8">
            <label class="label">
              Please attach site/event map that indicates the area that need to be marked
              out.
            </label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label
                class="label"
              >Will the event include amplified music, drumming or public address system? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="amplifiedMusic"
                    name="amplifiedMusic"
                    v-model="amplifiedMusic"
                    :class="{ 'is-danger': $v.amplifiedMusic.$error }"
                    @blur="$v.amplifiedMusic.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.amplifiedMusic.$error && !$v.amplifiedMusic.required"
                  class="help is-danger"
                >
                  Please
                  select an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="amplifiedMusic == 'Yes'">
          <div class="column is-8">
            <div class="field">
              <div class="control">
                <textarea
                  rows="8"
                  placeholder="How will you manage the impacts of the noise? *"
                  :class="{ 'textarea': true, 'is-danger': $v.amplifiedMusicManagement.$error }"
                  @input="$v.amplifiedMusicManagement.$touch()"
                  id="amplifiedMusicManagement"
                  name="amplifiedMusicManagement"
                  v-model="amplifiedMusicManagement"
                ></textarea>
                <span
                  v-if="$v.amplifiedMusicManagement.$error && !$v.amplifiedMusicManagement.required"
                  class="help is-danger"
                >Management plan is required</span>
                <span
                  v-if="$v.amplifiedMusicManagement.$error && !$v.amplifiedMusicManagement.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <span
          v-if="$v.amplifiedMusicManagement.$error && !$v.amplifiedMusicManagement.required"
          class="help is-danger"
        >Management plan is required</span>
        <span
          v-if="$v.amplifiedMusicManagement.$error && !$v.amplifiedMusicManagement.AlphNumCharsValidator"
          class="help is-danger"
        >Invalid characters entered</span>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Will your event include fire? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="eventFire"
                    name="eventFire"
                    v-model="eventFire"
                    :class="{ 'is-danger': $v.eventFire.$error }"
                    @blur="$v.eventFire.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span v-if="$v.eventFire.$error && !$v.eventFire.required" class="help is-danger">
                  Please select an
                  option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="eventFire == 'Yes'">
          <div class="columns" v-if="eventFire == 'Yes'">
            <div class="column is-8">
              <div class="field">
                <div class="control">
                  <textarea
                    rows="3"
                    placeholder="Please describe the nature/scope of the fire/fuel source/fire protection equipment *"
                    :class="{ 'textarea': true, 'is-danger': $v.eventFireScope.$error }"
                    @blur="$v.eventFireScope.$touch()"
                    id="eventFireScope"
                    name="eventFireScope"
                    v-model="eventFireScope"
                  ></textarea>
                  <span
                    v-if="$v.eventFireScope.$error && !$v.eventFireScope.required"
                    class="help is-danger"
                  >
                    Scope of
                    fire is required
                  </span>
                  <span
                    v-if="$v.eventFireScope.$error && !$v.eventFireScope.AlphNumCharsValidator"
                    class="help is-danger"
                  >Invalid characters entered</span>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8">
              <label class="label">Please include any images/ diagrams.</label>
              <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Will the event include fireworks? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="eventFireworks"
                    name="eventFireworks"
                    v-model="eventFireworks"
                    :class="{ 'is-danger': $v.eventFireworks.$error }"
                    @blur="$v.eventFireworks.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventFireworks.$error && !$v.eventFireworks.required"
                  class="help is-danger"
                >
                  Please
                  select an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="eventFireworks == 'Yes'">
          <div class="column is-8">
            <label class="label">Please attach a copy of the following documents:</label>
            <ol style="margin-left: 1em; margin-bottom: 1em; font-size: .8em;">
              <li>Pyro technicians licence,</li>
              <li>Public liability insurance certificate,</li>
              <li>Risk assessment,</li>
              <li>Written approval from Safework SA,</li>
              <li>Schedule 9/10 permit from the Country Fire Service.</li>
            </ol>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Will you undertake a community consultation/notification process for the event, so
                that the local residents and businesses can contact you on the event day and address any issues
                immediately (ie rubbish, traffic, parking, noise, etc)? *
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="eventCommunityConsultation"
                    name="eventCommunityConsultation"
                    v-model="eventCommunityConsultation"
                    :class="{ 'is-danger': $v.eventCommunityConsultation.$error }"
                    @blur="$v.eventCommunityConsultation.$touch()"
                  >
                    <option selected :value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.eventCommunityConsultation.$error && !$v.eventCommunityConsultation.required"
                  class="help is-danger"
                >Please select an option</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="eventCommunityConsultation == 'Yes'">
          <div class="columns">
            <div class="column is-8">
              <div class="field">
                <div class="control">
                  <label class="label">What is your community consultation/notification strategy *</label>
                  <textarea
                    rows="8"
                    placeholder="Public Meeting, Letterbox Drop, Advertisment in the Messenger, Posters, Social Media."
                    :class="{ 'textarea': true, 'is-danger': $v.eventCommunityConsultationStrategy.$error }"
                    @blur="$v.eventCommunityConsultationStrategy.$touch()"
                    id="eventCommunityConsultationStrategy"
                    name="eventCommunityConsultationStrategy"
                    v-model="eventCommunityConsultationStrategy"
                  ></textarea>
                  <span
                    v-if="$v.eventCommunityConsultationStrategy.$error && !$v.eventCommunityConsultationStrategy.required"
                    class="help is-danger"
                  >Your community consultation strategy is required</span>
                  <span
                    v-if="$v.eventCommunityConsultationStrategy.$error && !$v.eventCommunityConsultationStrategy.AlphNumCharsValidator"
                    class="help is-danger"
                  >Invalid characters entered</span>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8">
              <label class="label">Please attach a copy of the strategy:</label>
              <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
            </div>
          </div>
        </div>

        <br />
        <br />
      </tab-content>

      <tab-content title="Additional Details" :before-change="validateStep4">
        <div class="columns">
          <div class="column is-12">
            <hr />
            <p class="title is-4">Traffic/Parking Details</p>
            <hr />
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Will your event be likely to cause any disruption to normal traffic flow in the areas
                surrounding the event? *
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="trafficDisruption"
                    name="trafficDisruption"
                    v-model="trafficDisruption"
                    :class="{ 'is-danger': $v.trafficDisruption.$error }"
                    @blur="$v.trafficDisruption.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.trafficDisruption.$error && !$v.trafficDisruption.required"
                  class="help is-danger"
                >
                  Please
                  select an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Will your event require roads to be closed, speed limits, pedestrian access or
                parking restrictions? *
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="trafficRoadChanges"
                    name="trafficRoadChanges"
                    v-model="trafficRoadChanges"
                    :class="{ 'is-danger': $v.trafficRoadChanges.$error }"
                    @blur="$v.trafficRoadChanges.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.trafficRoadChanges.$error && !$v.trafficRoadChanges.required"
                  class="help is-danger"
                >Please select an option</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="trafficRoadChanges == 'Yes' || trafficDisruption == 'Yes'">
          <div class="column is-8">
            <label class="label">Please attach a traffic management plan.</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">How many public car parks are available at the event site? *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="0"
                  :class="{ 'input': true, 'is-danger': $v.trafficCarParkCount.$error }"
                  @blur="$v.trafficCarParkCount.$touch()"
                  id="trafficCarParkCount"
                  name="trafficCarParkCount"
                  v-model="trafficCarParkCount"
                  style="width: 70px;"
                />
                <span
                  v-if="$v.trafficCarParkCount.$error && !$v.trafficCarParkCount.required"
                  class="help is-danger"
                >Number public car parks is required</span>
                <span
                  v-if="$v.trafficCarParkCount.$error && !$v.trafficCarParkCount.numeric"
                  class="help is-danger"
                >Invalid number entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Select transport options you will be actively promoting *</label>

              <div
                style="margin-bottom: 1em;"
                v-if="$v.transportOptionsSelected.$error && !$v.transportOptionsSelected.required && !transportOptionsOther"
              >
                <span class="help is-danger">You must select an option..</span>
              </div>

              <a
                v-for="item in transportOptions"
                :key="item.id"
                :id="'transportOptions'+item.name"
                class="button btnElements"
                :class="{ 'is-success': item.enabled }"
                @click="item.enabled = !item.enabled"
              >{{ item.label }}</a>
              <a
                class="button btnElements"
                id="transportOptionsOther"
                :class="{ 'is-success': transportOptionsOther }"
                @click="transportOptionsOther = !transportOptionsOther"
              >Other</a>

              <textarea
                v-if="transportOptionsOther"
                rows="3"
                placeholder="Please enter other transport options"
                :class="{ 'textarea': true, 'is-danger': $v.transportOptionsOtherDescription.$error }"
                @blur="$v.transportOptionsOtherDescription.$touch()"
                id="transportOptionsOtherDescription"
                name="transportOptionsOtherDescription"
                v-model="transportOptionsOtherDescription"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-12">
            <hr />
            <p class="title is-4">Waste Management Details</p>
            <hr />
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label
                class="label"
              >How many permanent Council toilets are available for your event? *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="0"
                  :class="{ 'input': true, 'is-danger': $v.councilToiletCount.$error }"
                  @blur="$v.councilToiletCount.$touch()"
                  id="legalEntityName"
                  name="councilToiletCount"
                  v-model="councilToiletCount"
                  style="width: 70px;"
                />
                <span
                  v-if="$v.councilToiletCount.$error && !$v.councilToiletCount.required"
                  class="help is-danger"
                >Number of Council toilets is required</span>
                <span
                  v-if="$v.councilToiletCount.$error && !$v.councilToiletCount.numeric"
                  class="help is-danger"
                >Invalid number entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="councilToiletCount > 0">
          <div class="column is-8">
            <div class="field">
              <div class="control">
                <textarea
                  rows="4"
                  placeholder="Who is responsible for cleaning/restocking the Council toilets before, during and after the event * (ie event organiser or name of waste/clean contractor)"
                  :class="{ 'textarea': true, 'is-danger': $v.councilToiletManagement.$error }"
                  @blur="$v.councilToiletManagement.$touch()"
                  id="councilToiletManagement"
                  name="councilToiletManagement"
                  v-model="councilToiletManagement"
                ></textarea>
                <span
                  v-if="$v.councilToiletManagement.$error && !$v.councilToiletManagement.required"
                  class="help is-danger"
                >Responsibility of Council toilets is required</span>
                <span
                  v-if="$v.councilToiletManagement.$error && !$v.councilToiletManagement.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">How many port-a-loos/toilets will be provided at the event? *</label>
              <div class="control">
                <input
                  type="text"
                  placeholder="0"
                  :class="{ 'input': true, 'is-danger': $v.wastePortalooCount.$error }"
                  @blur="$v.wastePortalooCount.$touch()"
                  id="legalEntityName"
                  name="wastePortalooCount"
                  v-model="wastePortalooCount"
                  style="width: 70px;"
                />
                <span
                  v-if="$v.wastePortalooCount.$error && !$v.wastePortalooCount.required"
                  class="help is-danger"
                >Number of port-a-loos is required</span>
                <span
                  v-if="$v.wastePortalooCount.$error && !$v.wastePortalooCount.numeric"
                  class="help is-danger"
                >Invalid number entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="wastePortalooCount > 0">
          <div class="column is-8">
            <div class="field">
              <div class="control">
                <textarea
                  rows="4"
                  placeholder="Who is responsible for cleaning/restocking the port-a-loos before, during and after the event * (ie event organiser or name of waste/clean contractor)"
                  :class="{ 'textarea': true, 'is-danger': $v.wastePortalooManagement.$error }"
                  @blur="$v.wastePortalooManagement.$touch()"
                  id="wastePortalooManagement"
                  name="wastePortalooManagement"
                  v-model="wastePortalooManagement"
                ></textarea>
                <span
                  v-if="$v.wastePortalooManagement.$error && !$v.wastePortalooManagement.required"
                  class="help is-danger"
                >Responsibilty of port-a-loos is required</span>
                <span
                  v-if="$v.wastePortalooManagement.$error && !$v.wastePortalooManagement.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-6">
            <div class="field">
              <label class="label">
                How many temporary Waste/Recycling and Green bins will you be supplying for your
                event? *
              </label>
              <div class="control level" style="margin-bottom: .5em;">
                <input
                  type="text"
                  placeholder="0"
                  class="level-item-left"
                  :class="{ 'input': true, 'is-danger': $v.wasteBinCount.$error }"
                  @blur="$v.wasteBinCount.$touch()"
                  id="legalEntityName"
                  name="wasteBinCount"
                  v-model="wasteBinCount"
                  style="width: 70px;"
                />
                <span class="level-item" style="display:inline; margin-left:1em;">Waste Bins</span>
                <span
                  v-if="$v.wasteBinCount.$error && !$v.wasteBinCount.required"
                  class="help is-danger"
                >
                  Number of
                  waste bins is required
                </span>
                <span
                  v-if="$v.wasteBinCount.$error && !$v.wasteBinCount.numeric"
                  class="help is-danger"
                >
                  Invalid number
                  entered
                </span>
              </div>

              <div class="control level" style="margin-bottom: 0;">
                <input
                  type="text"
                  placeholder="0"
                  class="level-item-left"
                  :class="{ 'input': true, 'is-danger': $v.recycleBinCount.$error }"
                  @input="$v.recycleBinCount.$touch()"
                  id="legalEntityName"
                  name="recycleBinCount"
                  v-model="recycleBinCount"
                  style="width: 70px;"
                />
                <span class="level-item" style="display:inline; margin-left:1em;">Recycling Bins</span>
                <span
                  v-if="$v.recycleBinCount.$error && !$v.recycleBinCount.required"
                  class="help is-danger"
                >
                  Number of
                  recycling bins is required
                </span>
                <span
                  v-if="$v.recycleBinCount.$error && !$v.recycleBinCount.numeric"
                  class="help is-danger"
                >
                  Invalid
                  number entered
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <div class="control">
                <label class="label">
                  Who is responsible for the event site and surrounding area cleaning before, during
                  and after the event *
                </label>
                <textarea
                  rows="4"
                  placeholder="ie event organiser or name of waste/clean contractor"
                  :class="{ 'textarea': true, 'is-danger': $v.wasteSiteCleaning.$error }"
                  @blur="$v.wasteSiteCleaning.$touch()"
                  id="wasteSiteCleaning"
                  name="wasteSiteCleaning"
                  v-model="wasteSiteCleaning"
                ></textarea>
                <span
                  v-if="$v.wasteSiteCleaning.$error && !$v.wasteSiteCleaning.required"
                  class="help is-danger"
                >Responsibility of site/area cleaning is required</span>
                <span
                  v-if="$v.wasteSiteCleaning.$error && !$v.wasteSiteCleaning.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <div class="control">
                <label
                  class="label"
                >What is the environmental sustainability strategy/plan for the event? *</label>
                <textarea
                  rows="4"
                  placeholder="ie No one use plastics, 3 bin waste system, now straws"
                  :class="{ 'textarea': true, 'is-danger': $v.wasteSustainabilityStrategy.$error }"
                  @blur="$v.wasteSustainabilityStrategy.$touch()"
                  id="wasteSustainabilityStrategy"
                  name="wasteSustainabilityStrategy"
                  v-model="wasteSustainabilityStrategy"
                ></textarea>
                <span
                  v-if="$v.wasteSustainabilityStrategy.$error && !$v.wasteSustainabilityStrategy.required"
                  class="help is-danger"
                >Plan is required</span>
                <span
                  v-if="$v.wasteSustainabilityStrategy.$error && !$v.wasteSustainabilityStrategy.AlphNumCharsValidator"
                  class="help is-danger"
                >Invalid characters entered</span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns">
          <div class="column is-12">
            <hr />
            <p class="title is-4">Food/Health Details</p>
            <hr />
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Will food be served at your event? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="foodServed"
                    name="foodServed"
                    v-model="foodServed"
                    :class="{ 'is-danger': $v.foodServed.$error }"
                    @blur="$v.foodServed.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span v-if="$v.foodServed.$error && !$v.foodServed.required" class="help is-danger">
                  Please select an
                  option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="foodServed == 'Yes'">
          <div class="column is-8">
            <span>Please complete the following Online Form one month prior to the event:</span>
            <br />
            <a
              target="_blank"
              href="/onlineform/events-food-safety"
            >Special Events Food Safety Notification Form</a>
          </div>
        </div>

        <div class="columns">
          <div class="column is-8">
            <div class="field">
              <label class="label">Will alcohol be served at your event? *</label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="alcoholServed"
                    name="alcoholServed"
                    v-model="alcoholServed"
                    :class="{ 'is-danger': $v.alcoholServed.$error }"
                    @blur="$v.alcoholServed.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.alcoholServed.$error && !$v.alcoholServed.required"
                  class="help is-danger"
                >
                  Please select
                  an option
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="columns" v-if="alcoholServed == 'Yes'">
          <div class="column is-8">
            <div class="field">
              <label class="label">
                Have you applied for a temporary license from the Office of Liquor and Gambling?
                *
              </label>
              <div class="control">
                <div class="select" style="vertical-align: middle;">
                  <select
                    id="liquorLicenseOffice"
                    name="liquorLicenseOffice"
                    v-model="liquorLicenseOffice"
                    :class="{ 'is-danger': $v.liquorLicenseOffice.$error }"
                    @blur="$v.liquorLicenseOffice.$touch()"
                  >
                    <option selected value="null">--Please select--</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <span
                  v-if="$v.liquorLicenseOffice.$error && !$v.liquorLicenseOffice.required"
                  class="help is-danger"
                >Please select an option</span>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
      </tab-content>

      <tab-content title="Fees/Bonds" :before-change="validateStep5">
        <div class="column is-12">
          <div class="notification is-warning">
            <p>
              <strong>Agreement *</strong>
            </p>
            <ul>
              <li>
                <div class="form-check">
                  <label class="form-check-label" for="acceptEventPermitTimeframe">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="acceptEventPermitTimeframe"
                      id="acceptEventPermitTimeframe"
                      value="Yes"
                      :checked="acceptEventPermitTimeframe"
                      @click="acceptEventPermitTimeframe = !acceptEventPermitTimeframe"
                    />&nbsp;
                    I understand that the event permit application must be submitted to Council 2 months prior to the
                    event.
                  </label>
                </div>
              </li>
              <li>
                <div class="form-check">
                  <label class="form-check-label" for="acceptReviewedPAECharges">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      name="acceptReviewedPAECharges"
                      id="acceptReviewedPAECharges"
                      value="Yes"
                      :checked="acceptReviewedPAECharges"
                      @click="acceptReviewedPAECharges = !acceptReviewedPAECharges"
                    />&nbsp;
                    I have reviewed the current Council Fees and Charges document.
                  </label>
                </div>
              </li>
            </ul>

            <div class="form-check">
              <label class="form-check-label" for="acceptProvideFurtherInformation">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="acceptProvideFurtherInformation"
                  id="acceptProvideFurtherInformation"
                  value="Yes"
                  :checked="acceptProvideFurtherInformation"
                  @click="acceptProvideFurtherInformation = !acceptProvideFurtherInformation"
                />&nbsp;
                I understand that I may be asked to provide further documentation.
              </label>
            </div>

            <div class="form-check">
              <label class="form-check-label" for="awareSection33">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="awareSection33"
                  id="awareSection33"
                  value="Yes"
                  :checked="awareSection33"
                  @click="awareSection33 = !awareSection33"
                />&nbsp;
                I am aware the City of Port Adelaide Enfield may be obliged to carry out notification in accordance with Section 33 Road Traffic Act 1961 and if so will provide this traffic management plan for review on the City of Port Adelaide Enfield's website.
              </label>
            </div>

            <div class="form-check">
              <label class="form-check-label" for="agreement">
                <input
                  type="checkbox"
                  class="form-check-input"
                  name="agreement"
                  id="agreement"
                  value="Yes"
                  :checked="agree"
                  @click="agree = !agree"
                />&nbsp;
                <strong>I hereby declare that the information provided is true and correct.</strong>
              </label>
            </div>

            <p class="box" style="margin-top: 1em;">
              <strong>{{ applicantFirstName }} {{ applicantLastName }}</strong>
              <br />
              {{ legalEntityName }}
              <br />
              {{ applicantPosition }}
              <br />
              {{ today }}
            </p>



          </div>
        </div>

        <br />
        <br />
      </tab-content>

      <div class="column is-8" v-if="enableGoogleCaptch">
        <div class="field">
          <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="googleCaptchaKey"
          ></vue-recaptcha>
        </div>
      </div>

      <div class="modal" v-bind:class="{'is-active' : loading}">
        <div class="modal-background"></div>
        <div class="modal-content has-text-centered">
          <h1 class="title is-3 has-text-light">Please wait...</h1>
          <button
            class="button is-info is-loading is-fullwidth is-large"
            style="font-size: 5em; background: transparent;"
          >Submitting</button>
        </div>
      </div>

      <hr />
    </form-wizard>
  </div>
</template>

<style>
.btnElements {
    margin-right: 0.4em;
    margin-bottom: 0.4em;
}

.addPaddingTop1em {
    padding-top: 1em;
}
</style>

<script>
const isDate = value => moment(value, "DD/MM/YYYY", true).isValid();

import VueRecaptcha from "vue-recaptcha";

import PropertyAddress from "../../../../../../resources/assets/js/components/address/Typeahead-CouncilAddress.vue";
import GoogleAddressAutocomplete from "../../../../../../resources/assets/js/components/address/GoogleAddressAutocomplete.vue";

import FileDragDropInstant from "../../../../../../Modules/FileManagement/Resources/assets/js/components/FileDragDropInstant.vue";

import {
    alpha,
    required,
    requiredIf,
    email,
    numeric,
    alphaNum,
    minValue,
    maxValue,
    minLength
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import moment from "moment";

// Custom Validators
import { TimeValidator } from "../../../../../../resources/assets/js/validators/time-validator";
import { AlphNumCharsValidator } from "../../../../../../resources/assets/js/validators/alpha-num-chars-validator";

import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import datepicker from "vuejs-datepicker";

export default {
    components: {
        PropertyAddress,
        GoogleAddressAutocomplete,
        FileDragDropInstant,
        VueRecaptcha,
        FormWizard,
        TabContent,
        datepicker
    },
    props: {
        form: {}
    },
    data() {
        return {
            today: moment(new Date()).format("DD/MM/YYYY"),
            googleCaptchaKey: "6LcyrE0UAAAAAExxoj3NBm1vA-WMu88CIigyzkBU",
            enableGoogleCaptch: false,
            csrf: "",
            formTitle: this.form,
            message: "",
            submitted: false,
            loading: false,
            fileIDs: [],
            // Date options
            format: "dd/MM/yyyy",
            disabled: {
                to: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate()
                )
            },
            //ApplicantFields
            legalEntityName: "",
            legalEntityType: null,
            applicantFirstName: "",
            applicantLastName: "",
            applicantPosition: "",
            applicantContactNumber: "",
            applicantEmail: "",
            applicantPostalAddress: "",
            applicantPostalAddressTyping: "",
            applicantPostalAddressPropertyNo: "",
            applicantPostalAddressNotFound: false,
            applicantPostalAddressPAE: 99,
            //EventFields
            eventLocationType: null,
            eventLocation: "",
            reserveName: null,
            eventLocationOtherReserve: "",
            eventLocationReserveKeys: null,
            eventLocationReserveElectricity: null,
            eventName: "",
            eventDescription: "",
            eventBumpInDates: [
                {
                    date: "",
                    timeFrom: "",
                    timeTo: ""
                }
            ],
            eventBumpOutDates: [
                {
                    date: "",
                    timeFrom: "",
                    timeTo: ""
                }
            ],
            eventDates: [
                {
                    date: "",
                    timeFrom: "",
                    timeTo: ""
                }
            ],
            eventPublic: null,
            eventType: null,
            eventEstimatedAttendance: "",
            eventTickets: [
                {
                    type: "",
                    price: ""
                }
            ],
            eventElements: [
                {
                    label: "Infrastructure",
                    name: "Infrastructure",
                    example: "marquees, pop-ups, seating, tables...",
                    enabled: false
                },
                {
                    label: "Vehicle",
                    name: "Vehicle",
                    example: "display, movement",
                    enabled: false
                },
                {
                    label: "Live Animals",
                    name: "LiveAnimals",
                    example: "",
                    enabled: false
                },
                {
                    label: "Group Sporting Activities",
                    name: "GroupSports",
                    example: "volleyball, cricket, soccer...",
                    enabled: false
                },
                {
                    label: "Individual Sporting Activities",
                    name: "IndividualSports",
                    example: "walking, running, riding...",
                    enabled: false
                },
                {
                    label: "Water Activities",
                    name: "WaterActivity",
                    example: "swimming, sailing, kayaking...",
                    enabled: false
                },
                {
                    label: "Street or Garden Decoration/Landscaping",
                    name: "Landscaping",
                    example: "",
                    enabled: false
                },
                {
                    label: "Art and Craft Activities",
                    name: "ArtCraft",
                    example: "",
                    enabled: false
                },
                {
                    label: "Artist, Buskers, Bands, Roving, Soloist, MC",
                    name: "Artists",
                    example: "",
                    enabled: false
                },
                {
                    label: "Education/Awareness Campaigns",
                    name: "Education",
                    example: "",
                    enabled: false
                },
                {
                    label: "Parade/March/Procession",
                    name: "Parade",
                    example: "",
                    enabled: false
                }
            ],
            eventElementsSelected: [],
            eventElementsOther: false,
            eventElementsOtherDescription: "",
            eventMarketingItems: [
                {
                    label: "Social Media",
                    name: "SocialMedia",
                    enabled: false
                },
                {
                    label: "Poster/Banners",
                    name: "Poster",
                    enabled: false
                },
                {
                    label: "Print/Newspapers",
                    name: "Print",
                    enabled: false
                },
                {
                    label: "Website",
                    name: "Website",
                    enabled: false
                },
                {
                    label: "Mailouts",
                    name: "Mailouts",
                    enabled: false
                },
                {
                    label: "Radio",
                    name: "Radio",
                    enabled: false
                },
                {
                    label: "Television",
                    name: "Television",
                    enabled: false
                }
            ],
            eventMarketingItemsSelected: [],
            eventMarketingItemsOther: false,
            eventMarketingItemsOtherDescription: "",
            eventMarketingItemsWebsites: [
                {
                    url: ""
                }
            ],
            eventCouncilFundedGrant: null,
            eventCouncilFundedGrantName: "",
            eventCouncilFundedGrantAmount: "",
            //DocumentsAndConfirmationFields
            notifiedEmergencyServices: null,
            securityPersonnelPresent: null,
            securityPersonnelCount: 0,
            eventAmusements: null,
            irrigationMarkout: null,
            amplifiedMusic: null,
            amplifiedMusicManagement: "",
            eventFire: null,
            eventFireScope: "",
            eventFireworks: null,
            eventCommunityConsultation: null,
            eventCommunityConsultationStrategy: "",
            //AdditionalDetailsFields
            wastePortalooCount: 0,
            wastePortalooManagement: "",
            councilToiletCount: 0,
            councilToiletManagement: "",
            wasteBinCount: 0,
            recycleBinCount: 0,
            wasteSiteCleaning: "",
            wasteSustainabilityStrategy: "",
            foodServed: null,
            alcoholServed: null,
            liquorLicenseOffice: null,
            trafficDisruption: null,
            trafficRoadChanges: null,
            trafficCarParkCount: 0,
            transportOptions: [
                {
                    label: "Public Transport",
                    name: "PublicTransport",
                    enabled: false
                },
                {
                    label: "Private Car",
                    name: "PrivateCar",
                    enabled: false
                },
                {
                    label: "Car Pooling",
                    name: "CarPooling",
                    enabled: false
                },
                {
                    label: "Walking",
                    name: "Walking",
                    enabled: false
                },
                {
                    label: "Taxi/Uber",
                    name: "Taxi",
                    enabled: false
                },
                {
                    label: "Bicycle",
                    name: "Bicycle",
                    enabled: false
                },
                {
                    label: "Private Bus Service",
                    name: "PrivateBus",
                    enabled: false
                }
            ],
            transportOptionsSelected: [],
            transportOptionsOther: false,
            transportOptionsOtherDescription: "",
            //FeesBondsFields
            acceptEventPermitTimeframe: false,
            acceptReviewedPAECharges: false,
            acceptProvideFurtherInformation: false,
            agree: false,
            awareSection33: false
        };
    },
    validations: {
        //TAB1
        legalEntityName: {
            required,
            AlphNumCharsValidator
        },
        legalEntityType: { required },
        applicantFirstName: {
            required,
            AlphNumCharsValidator,
            minLength: minLength(1)
        },
        applicantLastName: { required, AlphNumCharsValidator },
        applicantPosition: { required, AlphNumCharsValidator },
        applicantContactNumber: { required, AlphNumCharsValidator },
        applicantEmail: { required, email },

        applicantPostalAddressPAE: { required, maxValue: maxValue(2) },
        applicantPostalAddressPropertyNo: {
            required: requiredIf(function() {
                return (
                    this.applicantPostalAddressNotFound == false &&
                    this.applicantPostalAddressPAE == 1
                );
            })
        },
        applicantPostalAddress: {
            required: requiredIf(function() {
                return (
                    this.applicantPostalAddressPAE == 0 ||
                    this.applicantPostalAddressPAE == 2
                );
            })
        },

        formStep1: [
            "legalEntityName",
            "legalEntityType",
            "applicantFirstName",
            "applicantLastName",
            "applicantPosition",
            "applicantContactNumber",
            "applicantEmail",
            "applicantPostalAddressPAE",
            "applicantPostalAddressPropertyNo",
            "applicantPostalAddress"
        ],

        //TAB2
        eventLocationType: { required },
        eventLocationOtherReserve: {
            required: requiredIf(function() {
                return this.reserveName == "Other...";
            })
        },
        eventLocation: { required },
        eventLocationReserveKeys: {
            required: requiredIf(function() {
                return this.eventLocationType == "Reserve";
            })
        },
        eventLocationReserveElectricity: {
            required: requiredIf(function() {
                return this.eventLocationType == "Reserve";
            })
        },
        eventName: { required, AlphNumCharsValidator, minLength: minLength(1) },
        eventDescription: {
            required,
            AlphNumCharsValidator,
            minLength: minLength(1)
        },
        eventBumpInDates: {
            required,
            $each: {
                date: { required },
                timeFrom: { required },
                timeTo: { required }
            }
        },
        eventBumpOutDates: {
            required,
            $each: {
                date: { required },
                timeFrom: { required },
                timeTo: { required }
            }
        },
        eventDates: {
            required,
            $each: {
                date: { required },
                timeFrom: { required },
                timeTo: { required }
            }
        },
        eventPublic: { required },
        eventType: { required },
        eventEstimatedAttendance: { required, numeric },
        eventTickets: {
            required,
            $each: {
                price: { required },
                type: { required }
            }
        },
        eventElementsSelected: {
            required: requiredIf(function() {
                return !this.eventElementsOther;
            })
        },
        eventElementsOtherDescription: {
            required: requiredIf(function() {
                return this.eventElementsOther;
            })
        },
        eventMarketingItemsSelected: {
            required: requiredIf(function() {
                return !this.eventMarketingItemsOther;
            })
        },
        eventMarketingItemsOtherDescription: {
            required: requiredIf(function() {
                return this.eventMarketingItemsOther;
            })
        },
        eventMarketingItemsWebsites: {},
        eventCouncilFundedGrant: { required },
        eventCouncilFundedGrantName: {
            required: requiredIf(function() {
                return this.eventCouncilFundedGrant == "Yes";
            })
        },
        eventCouncilFundedGrantAmount: {
            required: requiredIf(function() {
                return this.eventCouncilFundedGrant == "Yes";
            })
        },

        formStep2: [
            "eventLocationType",
            "eventLocation",
            "eventLocationOtherReserve",
            "eventLocationReserveKeys",
            "eventLocationReserveElectricity",
            "eventName",
            "eventDescription",
            "eventBumpInDates",
            "eventBumpOutDates",
            "eventDates",
            "eventPublic",
            "eventType",
            "eventEstimatedAttendance",
            "eventTickets",
            "eventElementsSelected",
            "eventElementsOtherDescription",
            "eventMarketingItemsSelected",
            "eventMarketingItemsOtherDescription",
            "eventCouncilFundedGrant",
            "eventCouncilFundedGrantName",
            "eventCouncilFundedGrantAmount"
        ],

        //TAB3
        notifiedEmergencyServices: { required },
        securityPersonnelPresent: { required },
        securityPersonnelCount: { required, numeric },
        eventAmusements: { required },
        irrigationMarkout: { required },
        amplifiedMusic: { required },
        amplifiedMusicManagement: {
            required: requiredIf(function() {
                return this.amplifiedMusic == "Yes";
            })
        },
        eventFire: { required },
        eventFireScope: {
            required: requiredIf(function() {
                return this.eventFire == "Yes";
            })
        },
        eventFireworks: { required },
        eventCommunityConsultation: { required },
        eventCommunityConsultationStrategy: {
            required: requiredIf(function() {
                return this.eventCommunityConsultation == "Yes";
            })
        },

        formStep3: [
            "notifiedEmergencyServices",
            "securityPersonnelPresent",
            "securityPersonnelCount",
            "eventAmusements",
            "irrigationMarkout",
            "amplifiedMusic",
            "amplifiedMusicManagement",
            "eventFire",
            "eventFireScope",
            "eventFireworks",
            "eventCommunityConsultation",
            "eventCommunityConsultationStrategy"
        ],

        //TAB4
        wastePortalooCount: { required, numeric },
        wastePortalooManagement: {
            required: requiredIf(function() {
                return this.wastePortalooCount > 0;
            }),
            AlphNumCharsValidator
        },
        councilToiletCount: { required, numeric },
        councilToiletManagement: {
            required: requiredIf(function() {
                return this.councilToiletCount > 0;
            }),
            AlphNumCharsValidator
        },
        wasteBinCount: { required, numeric },
        recycleBinCount: { required, numeric },
        wasteSiteCleaning: { required, AlphNumCharsValidator },
        wasteSustainabilityStrategy: { required, AlphNumCharsValidator },
        foodServed: { required },
        alcoholServed: { required },
        liquorLicenseOffice: {
            required: requiredIf(function() {
                return this.alcoholServed == "Yes";
            })
        },
        trafficDisruption: { required },
        trafficRoadChanges: { required },
        trafficCarParkCount: { required, numeric },
        transportOptionsSelected: {
            required: requiredIf(function() {
                return !this.transportOptionsOther;
            })
        },
        transportOptionsOtherDescription: {
            required: requiredIf(function() {
                return this.transportOptionsOther;
            })
        },

        formStep4: [
            "wastePortalooCount",
            "wastePortalooManagement",
            "councilToiletCount",
            "councilToiletManagement",
            "wasteBinCount",
            "recycleBinCount",
            "wasteSiteCleaning",
            "wasteSustainabilityStrategy",
            "foodServed",
            "alcoholServed",
            "liquorLicenseOffice",
            "trafficDisruption",
            "trafficRoadChanges",
            "trafficCarParkCount",
            "transportOptionsSelected",
            "transportOptionsOtherDescription"
        ],

        //TAB5
        acceptEventPermitTimeframe: { required },
        acceptReviewedPAECharges: { required },
        acceptProvideFurtherInformation: { required },
        agree: { required },
        awareSection33: { required },

        formStep5: [
            "acceptEventPermitTimeframe",
            "acceptReviewedPAECharges",
            "acceptProvideFurtherInformation",
            "agree",
            "awareSection33"
        ]
    },
    watch: {
        message: function(val) {
            if (!val === "") {
                this.loading = false;
            }
        },
        applicantPostalAddressPAE: function(val) {
            if (val == 2) {
                this.clearApplicantPostalAddress();
            } else if (val == 1) {
                this.applicantPostalAddressPAE = 1;
                this.clearApplicantPostalAddress();
            } else {
                this.applicantPostalAddressPAE = 0;
                this.clearApplicantPostalAddress();
            }
        },
        eventLocationType: function(val) {
            this.clearEventLocation();
            this.clearEventLocationReserveItems();
        },
        eventElements: {
            handler(val) {
                let self = this;
                self.eventElementsSelected = [];
                val.forEach(function(el, index) {
                    if (el.enabled == true) {
                        self.eventElementsSelected.push(el.label);
                    }
                });
                if (this.eventElementsOther == true) {
                    this.eventElementsSelected.push("Other");
                }
            },
            deep: true
        },
        eventElementsOther: {
            handler(val) {
                if (this.eventElementsOther == true) {
                    this.eventElementsSelected.push("Other");
                } else {
                    this.eventElementsSelected.splice(
                        this.eventElementsSelected.indexOf("Other"),
                        1
                    );
                }
            }
        },

        eventMarketingItems: {
            handler(val) {
                let self = this;
                self.eventMarketingItemsSelected = [];
                val.forEach(function(el, index) {
                    if (el.enabled == true) {
                        self.eventMarketingItemsSelected.push(el.label);
                    }
                });
                if (this.eventMarketingItemsOther == true) {
                    this.eventMarketingItemsSelected.push("Other");
                }
            },
            deep: true
        },

        eventMarketingItemsOther: {
            handler(val) {
                if (this.eventMarketingItemsOther == true) {
                    this.eventMarketingItemsSelected.push("Other");
                } else {
                    this.eventMarketingItemsSelected.splice(
                        this.eventMarketingItemsSelected.indexOf("Other"),
                        1
                    );
                }
            }
        },

        transportOptions: {
            handler(val) {
                let self = this;
                self.transportOptionsSelected = [];
                val.forEach(function(el, index) {
                    if (el.enabled == true) {
                        self.transportOptionsSelected.push(el.label);
                    }
                });
                if (this.transportOptionsOther == true) {
                    this.transportOptionsSelected.push("Other");
                }
            },
            deep: true
        },

        transportOptionsOther: {
            handler(val) {
                if (this.transportOptionsOther == true) {
                    this.transportOptionsSelected.push("Other");
                } else {
                    this.transportOptionsSelected.splice(
                        this.transportOptionsSelected.indexOf("Other"),
                        1
                    );
                }
            }
        }
    },
    computed: {
        fullName: function() {
            return this.applicantFirstName + " " + this.applicantLastName;
        },
        precis: function() {
            return (
                "Event Application - " +
                this.legalEntityName +
                " - " +
                this.eventName
            );
        },

        displayActiveTabIndex() {
            let wizard = this.$refs.wizard;
            return "test";
            return wizard.activeTabIndex;
        },

        formData: function() {
            var fields = {};
            fields.fileIDs = this.fileIDs;

            //tab1
            fields.legalEntityName = this.legalEntityName;
            fields.legalEntityType = this.legalEntityType;
            fields.applicantFirstName = this.applicantFirstName;
            fields.applicantLastName = this.applicantLastName;
            fields.applicantPosition = this.applicantPosition;
            fields.applicantContactNumber = this.applicantContactNumber;
            fields.applicantEmail = this.applicantEmail;
            if (
                this.applicantPostalAddressPropertyNo >= 0 ||
                this.applicantPostalAddressPAE == 2
            ) {
                fields.applicantPostalAddress = this.applicantPostalAddress;
            } else {
                fields.applicantPostalAddress = this.applicantPostalAddressTyping;
            }
            // fields.applicantPostalAddress =
            //   this.applicantPostalAddressPropertyNo >= 0
            //     ? this.applicantPostalAddress
            //     : this.applicantPostalAddressTyping;
            fields.applicantPostalAddressPropertyNo =
                this.applicantPostalAddressPropertyNo > 0
                    ? this.applicantPostalAddressPropertyNo
                    : 0;

            //tab2
            fields.eventLocationType = this.eventLocationType;
            fields.eventLocation =
                this.eventLocationType == "Reserve"
                    ? this.eventLocation
                    : this.eventLocation;

            fields.eventLocationReserveKeys = this.eventLocationReserveKeys;
            fields.eventLocationReserveElectricity = this.eventLocationReserveElectricity;
            fields.eventName = this.eventName;
            fields.eventDescription = this.eventDescription;
            fields.eventBumpInDates = this.eventBumpInDates;
            fields.eventBumpOutDates = this.eventBumpOutDates;
            fields.eventDates = this.eventDates;
            fields.eventPublic = this.eventPublic;
            fields.eventType = this.eventType;
            fields.eventEstimatedAttendance = this.eventEstimatedAttendance;
            fields.eventTickets = this.eventTickets;
            if (this.eventElementsSelected.length > 0) {
                fields.eventElementsSelected = this.eventElementsSelected;
            }
            fields.eventElementsOther = this.eventElementsOther;
            fields.eventElementsOtherDescription = this.eventElementsOtherDescription;
            if (this.eventMarketingItemsSelected.length > 0) {
                fields.eventMarketingItemsSelected = this.eventMarketingItemsSelected;
            }
            fields.eventMarketingItemsOther = this.eventMarketingItemsOther;
            fields.eventMarketingItemsOtherDescription = this.eventMarketingItemsOtherDescription;
            fields.eventMarketingItemsWebsites = this.eventMarketingItemsWebsites;
            fields.eventCouncilFundedGrant = this.eventCouncilFundedGrant;
            fields.eventCouncilFundedGrantName = this.eventCouncilFundedGrantName;
            fields.eventCouncilFundedGrantAmount = this.eventCouncilFundedGrantAmount;
            //tab3
            fields.notifiedEmergencyServices = this.notifiedEmergencyServices;
            fields.securityPersonnelPresent = this.securityPersonnelPresent;
            fields.eventAmusements = this.eventAmusements;
            fields.irrigationMarkout = this.irrigationMarkout;
            fields.amplifiedMusic = this.amplifiedMusic;
            fields.amplifiedMusicManagement = this.amplifiedMusicManagement;
            fields.eventFire = this.eventFire;
            fields.eventFireScope = this.eventFireScope;
            fields.eventFireworks = this.eventFireworks;
            fields.eventCommunityConsultation = this.eventCommunityConsultation;
            fields.eventCommunityConsultationStrategy = this.eventCommunityConsultationStrategy;
            //tab4
            fields.wastePortalooCount = this.wastePortalooCount;
            fields.wastePortalooManagement = this.wastePortalooManagement;
            fields.councilToiletCount = this.councilToiletCount;
            fields.councilToiletManagement = this.councilToiletManagement;
            fields.wasteBinCount = this.wasteBinCount;
            fields.recycleBinCount = this.recycleBinCount;
            fields.wasteSiteCleaning = this.wasteSiteCleaning;
            fields.wasteSustainabilityStrategy = this.wasteSustainabilityStrategy;
            fields.foodServed = this.foodServed;
            fields.alcoholServed = this.alcoholServed;
            fields.liquorLicenseOffice = this.liquorLicenseOffice;
            fields.trafficDisruption = this.trafficDisruption;
            fields.trafficRoadChanges = this.trafficRoadChanges;
            fields.trafficCarParkCount = this.trafficCarParkCount;
            if (this.transportOptionsSelected.length > 0) {
                fields.transportOptionsSelected = this.transportOptionsSelected;
            }
            fields.transportOptionsOther = this.transportOptionsOther;
            fields.transportOptionsOtherDescription = this.transportOptionsOtherDescription;
            //tab5
            fields.acceptEventPermitTimeframe = this.acceptEventPermitTimeframe;
            fields.acceptReviewedPAECharges = this.acceptReviewedPAECharges;
            fields.acceptProvideFurtherInformation = this.acceptProvideFurtherInformation;
            fields.agree = this.agree;
            fields.awareSection33 = this.awareSection33;

            fields.subject = "16.6.1.11";
            
            var actions = [];
            actions.push("A16.6.1.9");
            fields.action = actions;

            return JSON.stringify(fields);
        }
    },
    mounted() {
        this.csrf = window.laravel.csrfToken;
        // set default value
    },
    methods: {
        // var children = tableFields.children;
        // for (var i = 0; i < children.length; i++) {
        //   var tableChild = children[i];
        // }

        scrollToTop() {
            window.scrollTo(0, 1100);
        },

        // FILE ATTACHMENT HANDLING
        saveFileIDs(value) {
            this.fileIDs = value;
        },
        appendFileIDs(value) {
            let self = this;
            value.forEach(function(v) {
                if (self.fileIDs.indexOf(v) < 0) {
                    self.fileIDs.push(v);
                }
            });
        },
        removeFileID(value) {
            this.fileIDs.splice(this.fileIDs.indexOf(value), 1);
        },
        // STEP VALIDATION
        validateStep1() {
            this.$v.formStep1.$touch();
            this.scrollToTop();
            return !this.$v.formStep1.$invalid;
        },
        validateStep2() {
            this.$v.formStep2.$touch();
            this.scrollToTop();
            return !this.$v.formStep2.$invalid;
        },
        validateStep3() {
            this.$v.formStep3.$touch();
            this.scrollToTop();
            return !this.$v.formStep3.$invalid;
        },
        validateStep4() {
            this.$v.formStep4.$touch();
            this.scrollToTop();
            return !this.$v.formStep4.$invalid;
        },
        validateStep5() {
            this.$v.formStep5.$touch();
            return !this.$v.formStep5.$invalid;
        },

        onSubmit() {
            if (this.validateStep5()) {
                if (this.enableGoogleCaptch) {
                    this.$refs.invisibleRecaptcha.execute();
                } else {
                    this.submitForm();
                }
            }
        },

        submitForm() {
            this.loading = true;
            axios
                .post("/onlineform/" + this.form, {
                    _token: this.csrf,
                    formTitle: this.formTitle,
                    fullName: this.fullName,
                    emailAddress: this.applicantEmail,
                    contactNumber: this.applicantContactNumber,
                    precis: this.precis,
                    formData: this.formData,
                    message: ""
                })
                .then(response => {
                    console.log(response.data.message);
                    this.message = response.data.message;
                    this.clear();
                    //this.submitted = true
                    setTimeout(() => (this.submitted = true), 5000);
                    this.loading = false;
                });
        },

        clear() {},

        // APPLICANT ADDRESS
        saveApplicantPostalAddress(value) {
            this.applicantPostalAddress = value;
        },
        saveApplicantPostalAddressTyping(value) {
            this.applicantPostalAddressTyping = value;
        },
        saveApplicantPostalAddressPropertyNo(value) {
            this.applicantPostalAddressPropertyNo = value;
        },
        clearApplicantPostalAddress() {
            this.applicantPostalAddress = "";
            this.applicantPostalAddressTyping = "";
            this.applicantPostalAddressPropertyNo = "";
        },
        // EVENT ADDRESS
        saveEventLocation(value) {
            //console.log(value)
            if (value == "null") {
                this.eventLocation = null;
            } else {
                this.eventLocation = value;
                if (this.reserveName != "Other...") {
                    this.eventLocationOtherReserve = "";
                }
            }
        },
        clearEventLocation() {
            this.eventLocation = "";
        },
        clearEventLocationReserveItems() {
            this.eventLocationReserveKeys = null;
            this.eventLocationReserveElectricity = null;
        },

        // DATE PICKER
        customFormatter(date) {
            return moment(date).format("DD/MM/YYYY");
        }
    }
};
</script>



// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/LayoutEventsReservesRoads.vue